import React from 'react';

import styles from './style.module.scss';

interface Props {
  children: any;
  color: string;
  flip?: boolean;
}

export default (props: Props) => {
  return (
    <span className={styles.underlineContainer}>
      {props.children}

      <span
        className={styles.underline}
        style={{ backgroundColor: props.color, transform: props.flip ? 'scaleX(-1)' : '' }}
      />
    </span>
  );
};
